import { render, staticRenderFns } from "./AppMainSchedule.vue?vue&type=template&id=487308e1&"
import script from "./AppMainSchedule.vue?vue&type=script&lang=ts&"
export * from "./AppMainSchedule.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports